import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { VersionService } from '../services/version-service';
import { VersionComponent } from "../version-component/version-component";

@Component({
  selector: 'app-footer-component',
  imports: [
    RouterLink,
    VersionComponent,
],
  templateUrl: './footer-component.html',
  styleUrl: './footer-component.css',
})
export class FooterComponent {
  versionService = inject(VersionService);
}
